<template>
  <div class="devices">
    <div class="devices__header">
      <h1 class="medium-title">Add Devices</h1>
    </div>
    <div class="devices__body">
      <div class="devices__body__left">
        <div class="devices__body__left__form">
          <div class="devices__body__left__form__container">
            <h1 class="subhead">Device</h1>
            <div class="devices__body__left__form__container__category">
              <adx-single-search-dropdown :label="`Location`" :optionsParam="locations" :class="['dropdown', !locationInputted ? 'warning' : '']" :value.sync="model.location_inside"/>
              <!-- <adx-select-dropdown :label="`Location`" :options="locations" :value.sync="model.location_inside"/> -->
            </div>
            <div class="devices__body__left__form__container__name">
              <adx-input :label="`Device Name`" :value.sync="model.location_detail"/>
            </div>
            <div class="devices__body__left__form__container__prices">
              <adx-select-dropdown :options="pricingOption" :value.sync="model.pricingType" class="dropdown"/>
              <adx-input :label="`Price per Day`" :value.sync="model.price" type="number"/>
            </div>
          </div>
          <div class="devices__body__left__form__container">
            <h1 class="subhead">Device Size</h1>
            <div class="devices__body__left__form__container__size">
              <adx-select-dropdown :options="sizeOption" :value.sync="model.sizeUnit" class="dropdown"/>
              <adx-input :label="`Media Size`" :value.sync="model.size" type="number"/>
            </div>
            <div class="devices__body__left__form__container__numbers">
              <adx-input :label="`Width`" :value.sync="model.width" :icon="`pixel`" type="number"/>
              <adx-input :label="`Height`" :value.sync="model.height" :icon="`pixel`" type="number"/>
              <adx-input :label="`Depth`" :value.sync="model.depth" :icon="`meter`" type="number"/>
              <adx-input :label="`Length`" :value.sync="model.length" :icon="`meter`" type="number"/>
            </div>
            <div class="devices__body__left__form__container__orientation">
              <adx-select-dropdown :label="`Orientation`" :options="orientationOption" :value.sync="model.orientation" class="dropdown"/>
              <adx-select-dropdown :label="`Media Type`" :options="mediaOption" :value.sync="model.media_type" class="dropdown"/>
              <adx-select-dropdown :label="`Supported Hardware`" :options="hardwareOption" :value.sync="model.hardware" class="dropdown"/>
            </div>
            <!-- <div class="devices__body__left__form__container__sound">
              <adx-checkbox :label="`Available with sounds`" :value="model.sound" :valueLabel="`sound`" />
            </div> -->
          </div>
          <div class="devices__body__left__form__container">
            <h1 class="subhead">Opening Hours</h1>
            <div class="devices__body__left__form__container__hours">
              <div>
                <adx-checkbox :label="`Set 24 hours All Day`" :value.sync="is24All" />
              </div>
              <div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`Monday`" :value.sync="openingHoursMonday"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[0].start?model.operatingHours[0].start:`Open at`" :list="openingHoursOption" @selected="selectedStart($event, 0)"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[0].end?model.operatingHours[0].end:`Close at`" :list="closeHoursOption" @selected="selectedEnd($event, 0)"/></div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`24 Hours`" :inputId="'allDayMonday'" :value.sync="allDayMonday"/></div>
              </div>
              <div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`Tuesday`" :value.sync="openingHoursTuesday"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[1].start?model.operatingHours[1].start:`Open at`" :list="openingHoursOption" @selected="selectedStart($event, 1)"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[1].end?model.operatingHours[1].end:`Close at`" :list="closeHoursOption" @selected="selectedEnd($event, 1)"/></div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`24 Hours`" :inputId="'allDayTuesday'" :value.sync="allDayTuesday"/></div>
              </div>
              <div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`Wednesday`" :value.sync="openingHoursWednesday"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[2].start?model.operatingHours[2].start:`Open at`" :list="openingHoursOption" @selected="selectedStart($event, 2)"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[2].end?model.operatingHours[2].end:`Close at`" :list="closeHoursOption" @selected="selectedEnd($event, 2)"/></div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`24 Hours`" :inputId="'allDayWednesday'" :value.sync="allDayWednesday"/></div>
              </div>
              <div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`Thursday`" :value.sync="openingHoursThursday"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[3].start?model.operatingHours[3].start:`Open at`" :list="openingHoursOption" @selected="selectedStart($event, 3)"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[3].end?model.operatingHours[3].end:`Close at`" :list="closeHoursOption" @selected="selectedEnd($event, 3)"/></div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`24 Hours`" :inputId="'allDayThursday'" :value.sync="allDayThursday"/></div>
              </div>
              <div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`Friday`" :value.sync="openingHoursFriday"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[4].start?model.operatingHours[4].start:`Open at`" :list="openingHoursOption" @selected="selectedStart($event, 4)"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[4].end?model.operatingHours[4].end:`Close at`" :list="closeHoursOption" @selected="selectedEnd($event, 4)"/></div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`24 Hours`" :inputId="'allDayFriday'" :value.sync="allDayFriday"/></div>
              </div>
              <div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`Saturday`" :value.sync="openingHoursSaturday"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[5].start?model.operatingHours[5].start:`Open at`" :list="openingHoursOption" @selected="selectedStart($event, 5)"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[5].end?model.operatingHours[5].end:`Close at`" :list="closeHoursOption" @selected="selectedEnd($event, 5)"/></div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`24 Hours`" :inputId="'allDaySaturday'" :value.sync="allDaySaturday"/></div>
              </div>
              <div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`Sunday`" :value.sync="openingHoursSunday"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[6].start?model.operatingHours[6].start:`Open at`" :list="openingHoursOption" @selected="selectedStart($event, 6)"/></div>
                <div><adx-dropdown-list :labelButton="model.operatingHours[6].end?model.operatingHours[6].end:`Close at`" :list="closeHoursOption" @selected="selectedEnd($event, 6)"/></div>
                <div class="checkbox-wrapper"><adx-checkbox :label="`24 Hours`" :inputId="'allDaySunday'" :value.sync="allDaySunday"/></div>
              </div>
            </div>
          </div>
          <div class="devices__body__left__form__container">
            <h1 class="subhead">Duration</h1>
            <div class="devices__body__left__form__container__duration">
              <adx-input :label="`Owner`" :value.sync="model.owner_duration" :icon="`second`" type="number"/>
              <adx-input :label="`ADX`" :value.sync="model.adx_duration" :icon="`second`" type="number"/>
              <adx-input :label="`Commercial`" :value.sync="model.commercial_duration" :icon="`second`" type="number"/>
            </div>
          </div>
          <div class="devices__body__left__form__container">
            <div class="devices__body__left__form__container__revenues">
              <h1 class="subhead">Revenue Sharing Schemes</h1>
              <div class="devices__body__left__form__container__revenues__adx">
                <adx-input class="left" :label="`User`" :value="adx" :disabled="true"/>
                <adx-input class="right" :label="`Percentage`" :value.sync="adxRevenueShare" :disabled="true" :icon="`percent`"/>
              </div>
              <div v-for="(revenue, index) in model.revenues" :key="index" class="devices__body__left__form__container__revenues__revenue">
                <div class="top">
                  <div><adx-single-search-dropdown :label="`User`" :optionsParam="userOption" :class="['dropdown']" :value.sync="revenue.user"/></div>
                  <div class="role"><adx-select-dropdown :label="`Role`" :options="rolesOption" :value.sync="revenue.role"/></div>
                  <div class="percentage"><adx-input :label="`Percentage`" :icon="`percent`" :value.sync="revenue.share"/></div>
                  <div class="icon-wrapper"><i @click="deleteRevenueShare(model.revenues, index)" class="icon-deleted"></i></div>
                </div>
              </div>
              <div class="line-wrapper">
                <hr class="line">
              </div>
              <div class="button">
                <button @click="addRevenueShare(model.revenues)" class="new">Add new</button>
              </div>
            </div>
          </div>
          <div class="devices__body__left__form__container">
            <div class="devices__body__left__form__container__discounts">
              <h1 class="subhead">Discount Sharing Schemes</h1>
              <div class="devices__body__left__form__container__discounts__adx">
                <adx-input class="left" :label="`User`" :value="adx" :disabled="true"/>
                <adx-input class="right" :label="`Percentage`" :value.sync="adxDiscountShare" :disabled="true" :icon="`percent`"/>
              </div>
              <div v-for="(discount, index) in model.discounts" :key="index" class="devices__body__left__form__container__discounts__discount">
                <div class="top">
                  <div><adx-single-search-dropdown :label="`User`" :optionsParam="userOption" :class="['dropdown']" :value.sync="discount.user"/></div>
                  <div class="role"><adx-select-dropdown :label="`Role`" :options="rolesOption" :value.sync="discount.role" class="short"/></div>
                  <div class="percentage"><adx-input :label="`Percentage`" :icon="`percent`" :value.sync="discount.share" class="short"/></div>
                  <div class="icon-wrapper"><i @click="deleteDiscountShare(model.discounts, index)" class="icon-deleted"></i></div>
                </div>
              </div>
              <div class="line-wrapper">
                <hr class="line">
              </div>
              <div class="button">
                <button @click="addDiscountShare(model.discounts)" class="new">Add new</button>
              </div>
            </div>
          </div>
          <div class="devices__body__left__form__container">
            <div class="devices__body__left__form__container__cuts">
              <h1 class="subhead">Cuts Sharing Schemes</h1>
              <div class="devices__body__left__form__container__cuts__adx">
                <adx-input class="left" :label="`User`" :value="adx" :disabled="true"/>
                <adx-input class="right" :label="`Percentage`" :value.sync="adxCutsShare" :disabled="true" :icon="`percent`"/>
              </div>
              <div v-for="(cut, index) in model.cuts" :key="index" class="devices__body__left__form__container__cuts__cut">
                <div class="top">
                  <div><adx-select-dropdown :label="`Cuts Name`" :options="cutsOption" :value.sync="cut.purpose" @selected="selectCut($event,cut.purpose)"/></div>
                  <div><adx-input :label="`Cuts Amount`" :value.sync="cut.purpose === 1 ? cut_amount_inet : cut_amount_elec" @uodatedValue="uodatedValue($event, cut.purpose)" type="number"/></div>
                  <!--<div><adx-input :label="`Cuts Amount`" :value.sync="cut.amount" /></div>-->
                  
                  <div class="icon-wrapper"><i @click="deleteCutsShare(model.cuts, index)" class="icon-deleted"></i></div>
                </div>
                <div class="middle">
                  <div><adx-single-search-dropdown :label="`User`" :optionsParam="userOption" :class="['dropdown']" :value.sync="cut.user"/></div>
                  <div class="role"><adx-select-dropdown :label="`Role`" :options="rolesOption" :value.sync="cut.role"/></div>
                  <div class="percentage"><adx-input :label="`Percentage`" :icon="`percent`" :value.sync="cut.share"/></div>
                  <div class="empty"></div>
                </div>
              </div>
              <div class="line-wrapper">
                <hr class="line">
              </div>
              <div class="button">
                <button @click="addCutsShare(model.cuts)" class="new">Add new</button>
              </div>
            </div>
          </div>
          <div class="devices__body__left__form__container">
            <div class="devices__body__left__form__container__images">
              <h1 class="subhead">Photos</h1>
              <div v-for="(image, index) in model.images" :key="index" class="devices__body__left__form__container__images__image">
                <div class="upload-wrapper">
                  <div class="top">
                    <div class="upload-button">
                      <input type="file" accept="image/*" @change="getFile($event, image)"
                      :name="`fileUpload`+index" :id="`fileUpload`+index" style="display: none;">
                      <label :for="`fileUpload`+index" class="button-input" >Add Image</label>
                    </div>
                    <div class="file-name">
                      <label>{{image.name}}</label>
                      <i v-if="image.name" @click="cancelImage(image)" class="adx-ic_cancel"></i>
                    </div>
                    <!-- <div class="right-line"></div> -->
                  </div>
                  <div class="line-wrapper">
                    <hr class="line">
                  </div>
                  <div class="bottom">
                    <div>
                      <adx-checkbox :label="`Set as 360 image`" :inputId="`image360`+index" :valueLabel.sync="image.is_360" :value.sync="image.is_360" />
                    </div>
                    <div>
                      <adx-checkbox :label="`Set as featured image`" :inputId="`featured`+index" :valueLabel.sync="image.is_primary" :value.sync="image.is_primary" />
                    </div>
                  </div>
                </div>
                <div class="icon-wrapper"><i @click="deleteImage(model.images, index)" class="icon-deleted"></i></div>
              </div>
              <div class="line-wrapper">
                <hr class="line">
              </div>
              <div class="button">
                <button @click="addImage(model.images)" class="new">Add new</button>
              </div>
            </div>
          </div>
        </div>
      </div>  
      <div class="devices__body__right">
        <div class="devices__body__right__status">
          <h1 class="subhead">Device Status</h1>
          <adx-select-dropdown :label="`Status`" :options="statusOption" :value.sync="model.status"/>
          <adx-select-dropdown :label="`Condition`" :options="conditionOption" :value.sync="model.condition"/>
        </div>
        <div class="button-div">
          <button class="btn-large primary" @click="save">Publish</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/Form/Input'
import SelectDropdown from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import Checkbox from '@/components/Form/Checkbox'
import SingleSearchDropdown from '@/components/Dropdown/SingleSearchDropdown'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import obj2fd from 'obj2fd'

export default {
  name: 'adx-add-new-device',
  components: {
    'adx-input': Input,
    'adx-select-dropdown': SelectDropdown,
    'adx-dropdown-list': ListDropdown,
    'adx-checkbox': Checkbox,
    'adx-single-search-dropdown': SingleSearchDropdown,
  },
  props: {

  },
  data() {
    return {
      adx: 'Adx',
      cut_amount: null,
      cut_amount_inet: null,
      cut_amount_elec: null,
      locationInputted: true,
      categoryOption : [],
      orientationOption : [],
      mediaOption : [],
      hardwareOption : [],
      openingHoursOption: [],
      closeHoursOption: [],
      rolesOption : [],
      cutsOption : [],
      is24All: null,
      flagInit: true,
      selectedLocation: null,
      openingHoursMonday: null,
      openingHoursTuesday: null,
      openingHoursWednesday: null,
      openingHoursThursday: null,
      openingHoursFriday: null,
      openingHoursSaturday: null,
      openingHoursSunday: null,
      allDayMonday: null,
      allDayTuesday: null,
      allDayWednesday: null,
      allDayThursday: null,
      allDayFriday: null,
      allDaySaturday: null,
      allDaySunday: null,
      model: {
        location_inside: null,
        location_detail: null,
        pricingType: 'day',
        price: null,
        sizeUnit: 'inch',
        size: null,
        width: null,
        height: null,
        depth: null,
        length: null,
        orientation: null,
        media_type: null,
        hardware: null,
        sound: null,
        owner_duration: null,
        adx_duration: null,
        commercial_duration: null,
        operatingHours: [
          {
              day_of_week: 1,
              start: null,
              end: null
          },
          {
              day_of_week: 2,
              start: null,
              end: null
          },
          {
              day_of_week: 3,
              start: null,
              end: null
          },
          {
              day_of_week: 4,
              start: null,
              end: null
          },
          {
              day_of_week: 5,
              start: null,
              end: null
          },
          {
              day_of_week: 6,
              start: null,
              end: null
          },
          {
              day_of_week: 7,
              start: null,
              end: null
          }
        ],
        duration: {
          adx: null,
          owner: null,
          commercial: null,
        },
        revenues: [
          {
            user: null,
            role: null,
            share: null
          }
        ],
        discounts: [
          {
            user: null,
            role: null,
            share: null
          }
        ],
        cuts: [
          {
            purpose: null,
            amount: null,
            user: null,
            role: null,
            share: null
          }
        ],
        images: [
          {
            name: null,
            image: null,
            is_360: null,
            is_primary: null
          }
        ],
        status: null,
        condition: null
      },
      sizeOption: [
        {
          'id': 0,
          'label': 'Inch',
          'value': 'inch'
        },
      ],
      pricingOption: [
        {
          'id': 0,
          'label': 'Price Per Day',
          'value': 'day'
        },
      ],
      userOption: [],
      statusOption: [
        {
          'id': 0,
          'label': 'Public',
          'value': true
        },
        {
          'id': 1,
          'label': 'Private',
          'value': false
        }
      ],
      conditionOption: [
        {
          'id': 0,
          'label': 'Active',
          'value': true
        },
        {
          'id': 1,
          'label': 'Inactive',
          'value': false
        }
      ],
      locations: []
    }
  },
  computed: {
    adxRevenueShare() {
      let adxShare = 100
      let existing_shares = 0
      this.model.revenues.map(revenue => {
        existing_shares += parseFloat(revenue.share) || 0
      })
      return adxShare - existing_shares
    },
    adxDiscountShare() {
      let adxShare = 100
      let existing_shares = 0
      this.model.discounts.map(discount => {
        existing_shares += parseFloat(discount.share) || 0
      })
      return adxShare - existing_shares
    },
    adxCutsShare() {
      let adxShare = 100
      let existing_shares = 0
      this.model.cuts.map(cut => {
        existing_shares += parseFloat(cut.share) || 0
      })
      return adxShare - existing_shares
    },
  },
  watch: {
   /* model:function () {
    },
    cut_amount:function () {
    },
    cut_amount_inet:function () {
      console.log("watch inet")
    },
    cut_amount_elec:function () {
      console.log("watch elec")
    },*/
    is24All: function () {
      if (this.is24All == true) {
        this.allDayMonday = true
        this.allDayTuesday = true
        this.allDayWednesday = true
        this.allDayThursday = true
        this.allDayFriday = true
        this.allDaySaturday = true
        this.allDaySunday = true
      } else if (this.flagInit) {
        this.openingHoursMonday = false
        this.openingHoursTuesday = false
        this.openingHoursWednesday = false
        this.openingHoursThursday = false
        this.openingHoursFriday = false
        this.openingHoursSaturday = false
        this.openingHoursSunday = false
      }
      this.flagInit = true
    },
    openingHoursMonday: function () {
      if (this.openingHoursMonday == true){
        this.model.operatingHours[0].day_of_week = 1
      } else {
        this.allDayMonday = false
        this.model.operatingHours[0].day_of_week = null
        this.model.operatingHours[0].start = null
        this.model.operatingHours[0].end = null
      }
    },
    openingHoursTuesday: function () {
      if (this.openingHoursTuesday == true){
        this.model.operatingHours[1].day_of_week = 2
      } else {
        this.allDayTuesday = false
        this.model.operatingHours[1].day_of_week = null
        this.model.operatingHours[1].start = null
        this.model.operatingHours[1].end = null
      }
    },
    openingHoursWednesday: function () {
      if (this.openingHoursWednesday == true){
        this.model.operatingHours[2].day_of_week = 3
      } else {
        this.allDayWednesday = false
        this.model.operatingHours[2].day_of_week = null
        this.model.operatingHours[2].start = null
        this.model.operatingHours[2].end = null
      }
    },
    openingHoursThursday: function () {
      if (this.openingHoursThursday == true){
        this.model.operatingHours[3].day_of_week = 4
      } else {
        this.allDayThursday = false
        this.model.operatingHours[3].day_of_week = null
        this.model.operatingHours[3].start = null
        this.model.operatingHours[3].end = null
      }
    },
    openingHoursFriday: function () {
      if (this.openingHoursFriday == true){
        this.model.operatingHours[4].day_of_week = 5
      } else {
        this.allDayFriday = false
        this.model.operatingHours[4].day_of_week = null
        this.model.operatingHours[4].start = null
        this.model.operatingHours[4].end = null
      }
    },
    openingHoursSaturday: function () {
      if (this.openingHoursSaturday == true){
        this.model.operatingHours[5].day_of_week = 6
      } else {
        this.allDaySaturday = false
        this.model.operatingHours[5].day_of_week = null
        this.model.operatingHours[5].start = null
        this.model.operatingHours[5].end = null
      }
    },
    openingHoursSunday: function () {
      if (this.openingHoursSunday == true){
        this.model.operatingHours[6].day_of_week = 7
      } else {
        this.allDaySunday = false
        this.model.operatingHours[6].day_of_week = null
        this.model.operatingHours[6].start = null
        this.model.operatingHours[6].end = null
      }
    },
    allDayMonday: function () {
      if (this.allDayMonday == true) {
        this.openingHoursMonday = true
        this.model.operatingHours[0].start = this.openingHoursOption[0].value
        this.model.operatingHours[0].end = this.openingHoursOption[0].value
        if (this.validation24Hours()) {
          this.is24All = true
        }
      } else if (this.is24All == true) {
        this.flagInit = false
        this.is24All = false
      }
    },
    allDayTuesday: function () {
      if (this.allDayTuesday == true) {
        this.openingHoursTuesday = true
        this.model.operatingHours[1].start = this.openingHoursOption[0].value
        this.model.operatingHours[1].end = this.openingHoursOption[0].value
        if (this.validation24Hours()) {
          this.is24All = true
        }
      } else if (this.is24All == true) {
        this.flagInit = false
        this.is24All = false
      }
    },
    allDayWednesday: function () {
      if (this.allDayWednesday == true) {
        this.openingHoursWednesday = true
        this.model.operatingHours[2].start = this.openingHoursOption[0].value
        this.model.operatingHours[2].end = this.openingHoursOption[0].value
        if (this.validation24Hours()) {
          this.is24All = true
        }
      } else if (this.is24All == true) {
        this.flagInit = false
        this.is24All = false
      }
    },
    allDayThursday: function () {
      if (this.allDayThursday == true) {
        this.openingHoursThursday = true
        this.model.operatingHours[3].start = this.openingHoursOption[0].value
        this.model.operatingHours[3].end = this.openingHoursOption[0].value
        if (this.validation24Hours()) {
          this.is24All = true
        }
      } else if (this.is24All == true) {
        this.flagInit = false
        this.is24All = false
      }
    },
    allDayFriday: function () {
      if (this.allDayFriday == true) {
        this.openingHoursFriday = true
        this.model.operatingHours[4].start = this.openingHoursOption[0].value
        this.model.operatingHours[4].end = this.openingHoursOption[0].value
        if (this.validation24Hours()) {
          this.is24All = true
        }
      } else if (this.is24All == true) {
        this.flagInit = false
        this.is24All = false
      }
    },
    allDaySaturday: function () {
      if (this.allDaySaturday == true) {
        this.openingHoursSaturday = true
        this.model.operatingHours[5].start = this.openingHoursOption[0].value
        this.model.operatingHours[5].end = this.openingHoursOption[0].value
        if (this.validation24Hours()) {
          this.is24All = true
        }
      } else if (this.is24All == true) {
        this.flagInit = false
        this.is24All = false
      }
    },
    allDaySunday: function () {
      if (this.allDaySunday == true) {
        this.openingHoursSunday = true
        this.model.operatingHours[6].start = this.openingHoursOption[0].value
        this.model.operatingHours[6].end = this.openingHoursOption[0].value
        if (this.validation24Hours()) {
          this.is24All = true
        }
      } else if (this.is24All == true) {
        this.flagInit = false
        this.is24All = false
      }
    }
  },
  beforeCreate() {

  },
  created() {
    this.getDropdownOptions()
  },
  beforeMount() {
    
  },
  mounted() {
  
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    uodatedValue(value, purpose){
      if (purpose == 1) {
        this.cut_amount_inet = value
      } else {
        this.cut_amount_elec = value
      }
    },
    selectCut(value, purpose){
      //console.log(value, purpose)
    },
    getLocations() {
      (async () => {
        const { data } = await api.get(apiV2.locationsNameList, { needToken: true })
        for (var i=0; i < data.length; i++){
            this.locations.push(
                {
                  label: data[i].title,
                  value: data[i].id
                }
            )
        }
      })();
    },
    getUsers() {
      (async () => {
        const { data } = await api.get(apiV2.users, { needToken: true })
        for (var i=0; i < data.length; i++){
            this.userOption.push(
                {
                  label: data[i].email,
                  value: data[i].id
                }
            )
        }
      })();
    },
    getHours() {
      let file = `/static/data/hours.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();

        data.hours.map(hour => {
          this.openingHoursOption.push(
            {
              'id': hour.id,
              'label': hour.label,
              'value': hour.value
            }
          )
          this.closeHoursOption.push(
            {
              'id': hour.id,
              'label': hour.label,
              'value': hour.value
            }
          )
        })
      })();
    },
    getCategories() {
      let file = `/static/data/categories.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();

        data.categories.map(category => {
          this.categoryOption.push(
            {
              'label': category.title.charAt(0).toUpperCase() + category.title.substr(1),
              'value': category.value
            }
          )
        })
      })();
    },
    getOrientation() {
      let file = `/static/data/orientation.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();

        data.orientation.map(obj => {
          this.orientationOption.push(
            {
              'label': obj.label,
              'value': obj.value
            }
          )
        })
      })();
    },
    getRoles() {
      let file = `/static/data/roles.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();

        data.roles.map(obj => {
          this.rolesOption.push(
            {
              'label': obj.label,
              'value': obj.id
            }
          )
        })
      })();
    },
    getMedia() {
      let file = `/static/data/media_type.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();

        data.media_type.map(obj => {
          this.mediaOption.push(
            {
              'label': obj.label,
              'value': obj.value
            }
          )
        })
      })();
    },
    getHardware() {
      let file = `/static/data/hardware.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();

        data.hardware.map(obj => {
          this.hardwareOption.push(
            {
              'label': obj.label,
              'value': obj.value
            }
          )
        })
      })();
    },
    getCuts() {
      let file = `/static/data/cuts.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();

        data.cuts.map(obj => {
          this.cutsOption.push(
            {
              'label': obj.label,
              'value': obj.id
            }
          )
        })
      })();
    },
    getDropdownOptions() {
      this.getLocations()
      this.getUsers()
      this.getHours()
      this.getCategories()
      this.getOrientation()
      this.getMedia()
      this.getHardware()
      this.getRoles()
      this.getCuts()
    },
    convertOrientation(input){
      if (input == this.orientationOption[0].value){
        input = 0
      } else if (input == this.orientationOption[1].value){
        input = 90
      } else {
        input = 270
      }
      return input
    },
    convertRevenues(input){
      let dataRevenue = []
      input.map(rev => {
          if (rev.role || rev.share || rev.user){
            dataRevenue.push(
              {
                role: rev.role,
                share: rev.share,
                user: rev.user
              }
            )
          }
      })
      return dataRevenue;
    },
    convertDiscounts(input){
      let dataDiscount = []
      input.map(dis => {
          if (dis.role || dis.share || dis.user){
            dataDiscount.push(
              {
                role: dis.role,
                share: dis.share,
                user: dis.user
              }
            )
          }
      })
      return dataDiscount;
    },
    
    convertCuts(input){
      let dataCuts = []
      input.map(cut => {
          if (cut.amount || cut.purpose || cut.role || cut.share || cut.user){
            dataCuts.push(
              {
                amount : cut.purpose == 1 ? this.cut_amount_inet : this.cut_amount_elec,
                purpose : cut.purpose,
                role: cut.role,
                share: cut.share,
                user: cut.user
              }
            )
          }
      })
      return dataCuts;
    },
    convertOperationHours(input){
      let dataOH = []
      input.map(oh => {
        if (oh.start || oh.end){
          dataOH.push({
            day_of_week: oh.day_of_week-1,
            start : oh.start,
            end: oh.end
          })
        }
      })
      return dataOH
    },
    inputValidation(input) {
      let data = { isValid: true, errorMessage: null }
      let isValid = true
      if(input.location_inside == null) {
        data.isValid = false
        data.errorMessage = "You can't leave Location empty"
        isValid = false
      } else if (input.price == null){
        data.isValid = false
        data.errorMessage = "You can't leave Price empty"
        isValid = false
      } else if (input.orientation == null){
        data.isValid = false
        data.errorMessage = "You can't leave Orientation empty"
        isValid = false
      } else if (input.media_type == null){
        data.isValid = false
        data.errorMessage = "You can't leave Media Type empty"
        isValid = false
      } else if(input.hardware == null) {
        data.isValid = false
        data.errorMessage = "You can't leave Supported Hardware empty"
        isValid = false
      } else if(input.hours.length < 1) {
        data.isValid = false
        data.errorMessage = "You must fill the opening and closing time"
        isValid = false
      } else if (input.owner_duration == null){
        data.isValid = false
        data.errorMessage = "You can't leave Owner Duration empty"
        isValid = false
      } else if (input.adx_duration == null){
        data.isValid = false
        data.errorMessage = "You can't leave Adx Duration empty"
        isValid = false
      } else if (input.commercial_duration == null){
        data.isValid = false
        data.errorMessage = "You can't leave Commercial Duration empty"
        isValid = false
      } else if(input.is_public == null) {
        data.isValid = false
        data.errorMessage = "You can't leave Status empty"
        isValid = false
      } else if(input.is_active == null) {
        data.isValid = false
        data.errorMessage = "You can't leave Condition empty"
        isValid = false
      } else if (this.adxRevenueShare < 0 || this.adxRevenueShare > 100){
        data.isValid = false
        data.errorMessage = "Acceptable percentage for ADX in Revenue Share Scheme is 0-100"
        isValid = false
      } else if (this.adxDiscountShare < 0 || this.adxDiscountShare > 100){
        data.isValid = false
        data.errorMessage = "Acceptable percentage for ADX in Discout Share Scheme is 0-100"
        isValid = false
      } else if (this.adxCutsShare < 0 || this.adxCutsShare > 100){
        data.isValid = false
        data.errorMessage = "Acceptable percentage for ADX in Cut Sharing Scheme is 0-100"
        isValid = false
      }
      if (isValid && input.hours.length > 0){
        for (var i =0; i < input.hours.length; i++){
          if (!input.hours[i].start || !input.hours[i].end){
            data.isValid = false
            data.errorMessage = "You must fill the opening and closing time"
            isValid = false
          }
        }
      }
      if(isValid && input.revenues.length > 0) {
        for (var i=0; i < input.revenues.length; i++){
          if (!input.revenues[i].role || !input.revenues[i].share || !input.revenues[i].user){
              data.isValid = false
              data.errorMessage = "You can't leave Revenues Condition incomplete"
              return data
          }
          for (var j=i+1; j < input.revenues.length; j++){
            if (input.revenues[i].role == input.revenues[j].role ) {
              data.isValid = false
              data.errorMessage = "Revenue sharing scheme with this Role already exists."
              return data
            }
          }

        }
      }
      if(isValid && input.discounts.length > 0) {
        for (var i=0; i < input.discounts.length; i++){
          if (!input.discounts[i].role || !input.discounts[i].share || !input.discounts[i].user){
            data.isValid = false
            data.errorMessage = "You can't leave Discounts Condition incomplete"
            return data
          }
          for (var j=i+1; j < input.discounts.length; j++){
            if (input.discounts[i].role == input.discounts[j].role) {
              data.isValid = false
              data.errorMessage = "Discount sharing scheme with this Role already exists."
              return data
            }
          }
        }
      }  
      if(isValid && input.cuts.length > 0) {
        for (var i=0; i < input.cuts.length; i++){
          if (!input.cuts[i].amount || !input.cuts[i].purpose || !input.cuts[i].role || !input.cuts[i].share || !input.cuts[i].user){
              data.isValid = false
              data.errorMessage = "You can't leave Cuts Condition incomplete"
              return data
          }
          for (var j=i+1; j < input.cuts.length; j++){
           if (input.cuts[i].amount == input.cuts[j].amount && input.cuts[i].purpose == input.cuts[j].purpose && input.cuts[i].role == input.cuts[j].role) {
              data.isValid = false
              data.errorMessage = "Cuts sharing scheme with same Role already exists."
              return data
            }
          }
        }
      }

      return data
    },
    saveImages(pubId) {
      let args = pubId
      //Multiple photos
      let dataImage = []
      this.model.images.map(img => {
        dataImage.push(
          {
            image: img.image,
            is_360: img.is_360==null?false:img.is_360,
            is_primary: img.is_primary==null?false:img.is_primary
          }
        )
      })

      let data = { data: dataImage }
      let image = new FormData();
      image = obj2fd(data);

      (async () => {
        const response = await api.post(apiV2.deviceImage(args), image, { needToken: true })
      })();
    },
    save() {
      let operatingHours = []
      this.model.operatingHours
        .map(element => {
          if (element.start && element.end) {
            operatingHours.push(element)
          }
        })
      const body = {
        location_inside: this.model.location_inside,
        location_detail: this.model.location_detail,
        pricingType: this.model.pricingType,
        price: this.model.price,
        sizeUnit: this.model.sizeUnit,
        size: this.model.size ? this.model.size  : null ,
        width: this.model.width ? this.model.width : null,
        height: this.model.height ? this.model.height : null,
        depth: this.model.depth ? this.model.depth : null,
        length: this.model.length ? this.model.length : null,
        orientation: this.model.orientation,
        media_type: this.model.media_type,
        hardware: this.model.hardware,
        owner_duration: this.model.owner_duration,
        adx_duration: this.model.adx_duration,
        commercial_duration: this.model.commercial_duration,
        is_public: this.model.status,
        is_active: this.model.condition,
        hours: this.convertOperationHours(operatingHours),
        revenues: this.convertRevenues(this.model.revenues),
        discounts: this.convertDiscounts(this.model.discounts),
        cuts: this.convertCuts(this.model.cuts)
      }

      let validation = this.inputValidation(body)
      if (validation.isValid) {

        body.revenues
          .map(element => {
            element.share/=100
          })
        body.discounts
          .map(element => {
            element.share/=100
          })
        body.cuts
          .map(element => {
            element.share/=100
          });

        (async () => {
            const response = await api.post(apiV2.deviceCreate, body, { needToken: true })
            if (response.status === 201) {
              this.saveImages(response.data.pub_id)
              this.$notify({
                group: 'saved',
                title: 'Success',
                text: `Data successfully saved!`,
                type: 'success'
              });
              this.$router.push({name: 'devicelist'})
            } else {
              this.$notify({
                group: 'saved',
                title: 'Error',
                text: response.statusText,
                type: 'danger'
              });
            }
        })();
      } else {
        this.raiseError(validation.errorMessage)
      }
    },
    raiseError(errorMessage) {
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: errorMessage,
        type: 'danger'
      });
    },
    addDiscountShare(discounts) {
      discounts.push(
        {
          user: null,
          role: null,
          share: null
        }
      )
    },
    addRevenueShare(revenues) {
      revenues.push(
        {
          user: null,
          role: null,
          share: null
        }
      )
    },
    addCutsShare(cuts) {
      let len = cuts.length
      if (len){
        cuts.push(
          {
            purpose: cuts[len-1].purpose,
            amount: cuts[len-1].amount,
            user: null,
            role: null,
            share: null
          }
        )
      } else{
        cuts.push(
          {
            purpose: null,
            amount: null,
            user: null,
            role: null,
            share: null
          }
        )
      } 
    },
    addImage(image) {
      image.push(
        {
          name: null,
          data: null,
          is_360: null,
          is_primary: null
        }
      )
    },
    deleteDiscountShare(discounts, index) {
        discounts.splice(index, 1)
    },
    deleteRevenueShare(revenues, index) {
     // if (revenues.length > 1) {
        revenues.splice(index, 1)
      // } else {
      //   this.$notify({
      //     group: 'saved',
      //     title: 'Delete Error',
      //     text: 'Oops data can not be deleted!',
      //     type: 'danger'
      //   });
      // }
    },
    deleteCutsShare(cuts, index) {
      //if (cuts.length > 1) {
        cuts.splice(index, 1)
      /*} else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }*/
    },
    deleteImage(images, index) {
        images.splice(index, 1)
    },
    cancelImage(image) {
      image.name = null
      image.data = null
    },
    validateFile(file) {
      let maxSize = 2000000; // 2 MB
      let data = { is_valid: true }
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/)
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
        }
      } else {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
      }
      if (file.size > maxSize) {
        data.is_valid = false
        data.message = `File too large.`
        return data
      }
      const filename = file.name.split('.')[0]
      if (filename.length > 100) {
        data.is_valid = false
        data.message = 'File name is too long. Maximum size 100 character'
        return data
      }

      if (filename.includes('/')) {
        data.is_valid = false
        data.message = 'File name has forbidden character'
        return data
      }
      return data
    },
    getFile(event, image) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateFile(input.files[0])
        if (!validated_data.is_valid) {
          this.raiseError(validated_data.message)
        } else {
          reader.readAsDataURL(input.files[0]);
          image.name = input.files[0].name;
          image.image = input.files[0];
        }
      }
    },
    validateFile(file) {
      let maxSize = 2000000; // 2 MB
      let data = { is_valid: true }
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/)
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
        }
      } else {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
      }
      if (file.size > maxSize) {
        data.is_valid = false
        data.message = `File too large.`
        return data
      }
      const filename = file.name.split('.')[0]
      if (filename.length > 100) {
        data.is_valid = false
        data.message = 'File name is too long. Maximum size 100 character'
        return data
      }

      if (filename.includes('/')) {
        data.is_valid = false
        data.message = 'File name has forbidden character'
        return data
      }
      return data
    },
    launchFilePicker(fileUpload){
      fileUpload.click();
    },
    selectedStart(item, index){
      this.model.operatingHours[index].start = item.value
      if (this.model.operatingHours[index].start == this.openingHoursOption[0].value && this.model.operatingHours[index].end == this.openingHoursOption[0].value) {
        if (index==0) {
          this.allDayMonday = true
        } else if (index==1) {
          this.allDayTuesday = true
        } else if (index==2) {
          this.allDayWednesday = true
        } else if (index==3) {
          this.allDayThursday = true
        } else if (index==4) {
          this.allDayFriday = true
        } else if (index==5) {
          this.allDaySaturday = true
        } else if (index==6) {
          this.allDaySunday = true
        }
      } else {
        if (index==0) {
          this.allDayMonday = false
        } else if (index==1) {
          this.allDayTuesday = false
        } else if (index==2) {
          this.allDayWednesday = false
        } else if (index==3) {
          this.allDayThursday = false
        } else if (index==4) {
          this.allDayFriday = false
        } else if (index==5) {
          this.allDaySaturday = false
        } else if (index==6) {
          this.allDaySunday = false
        }
      }
      if (index==0) {
        this.openingHoursMonday = true
      } else if (index==1) {
        this.openingHoursTuesday = true
      } else if (index==2) {
        this.openingHoursWednesday = true
      } else if (index==3) {
        this.openingHoursThursday = true
      } else if (index==4) {
        this.openingHoursFriday = true
      } else if (index==5) {
        this.openingHoursSaturday = true
      } else if (index==6) {
        this.openingHoursSunday = true
      }
    },
    selectedEnd(item, index){
      this.model.operatingHours[index].end = item.value
      if (this.model.operatingHours[index].start == this.openingHoursOption[0].value && this.model.operatingHours[index].end == this.openingHoursOption[0].value) {
        if (index==0) {
          this.allDayMonday = true
        } else if (index==1) {
          this.allDayTuesday = true
        } else if (index==2) {
          this.allDayWednesday = true
        } else if (index==3) {
          this.allDayThursday = true
        } else if (index==4) {
          this.allDayFriday = true
        } else if (index==5) {
          this.allDaySaturday = true
        } else if (index==6) {
          this.allDaySunday = true
        }
      } else {
        if (index==0) {
          this.allDayMonday = false
        } else if (index==1) {
          this.allDayTuesday = false
        } else if (index==2) {
          this.allDayWednesday = false
        } else if (index==3) {
          this.allDayThursday = false
        } else if (index==4) {
          this.allDayFriday = false
        } else if (index==5) {
          this.allDaySaturday = false
        } else if (index==6) {
          this.allDaySunday = false
        }
      }
      if (index==0) {
        this.openingHoursMonday = true
      } else if (index==1) {
        this.openingHoursTuesday = true
      } else if (index==2) {
        this.openingHoursWednesday = true
      } else if (index==3) {
        this.openingHoursThursday = true
      } else if (index==4) {
        this.openingHoursFriday = true
      } else if (index==5) {
        this.openingHoursSaturday = true
      } else if (index==6) {
        this.openingHoursSunday = true
      }
    },
    reset() {
      this.model.location_inside = null
      this.model.location_detail = null
      this.model.pricingType = 'day'
      this.model.price = null
      this.model.sizeUnit = 'inch'
      this.model.size = null
      this.model.width = null
      this.model.height = null
      this.model.depth = null
      this.model.length = null
      this.model.orientation = null
      this.model.media_type = null
      this.model.hardware = null
      this.model.sound = null
      this.model.owner_duration = null
      this.model.adx_duration = null
      this.model.commercial_duration = null
      this.model.status = null
      this.model.condition = null
    },
    validation24Hours() {
      let retval = true
      for (var index = 0 ; index < 7 ; index++) {
        if (this.model.operatingHours[index].start == this.openingHoursOption[0].value && this.model.operatingHours[index].end == this.openingHoursOption[0].value) {
          if (index==0) {
            this.allDayMonday = true
          } else if (index==1) {
            this.allDayTuesday = true
          } else if (index==2) {
            this.allDayWednesday = true
          } else if (index==3) {
            this.allDayThursday = true
          } else if (index==4) {
            this.allDayFriday = true
          } else if (index==5) {
            this.allDaySaturday = true
          } else if (index==6) {
            this.allDaySunday = true
          }
        } else {
          retval = false
        }
      }
      return retval
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.devices {
  &__body {
    &__left {
      &__form {
        &__size {
          .selectDropdown {
            input {
              padding-top: 0;
            }
          }
        }
      }
    }
  }

  input {
    min-height: 62px;
  }

  .selectDropdown {
    .select {
      input {
        min-height: 62px;
      }
    }
  }

  .btn-regular {
    min-width: 97px;

    &.teal {
      background-color: $white;
      border: solid 1px $pale-grey;
      color: unset;
    }
  }

  .popup {
    &__input {
      &__dropdown {
        min-height: 24px;
      }
    }
  }
}
</style>
